import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@mui/material";
import { getProduct, getTargetValue } from "@/utils/social.ts";
import ProgressSection from "@/components/social/shared/ProgressSection.tsx";
import { Image } from "@/components/social/shared/Image.tsx";
import { Header } from "@/components/social/shared/Header.tsx";
import { Links } from "@/components/social/shared/Links.tsx";
import { Caption } from "@/components/social/shared/Caption.tsx";
import { Metrics } from "@/components/social/shared/Metrics.tsx";

const Story = ({ data, classes, children }) => {
  const product = getProduct(data.productId);
  const target =
    getTargetValue(
      product,
      data.packageType,
      data.kpiMetric,
      data.language || undefined,
    ) ?? 0;

  return (
    <Accordion
      elevation={0}
      variant="outlined"
      square
      classes={{
        root: classes.storyPanelUnder,
        expanded: classes.storyPanelExpanded,
      }}
    >
      <AccordionSummary
        style={{ margin: 0, width: "100%" }}
        expandIcon={
          <img
            src="/img/icons/chevron-down.svg"
            alt="Expand"
            style={{ width: "28px", height: "28px" }}
          />
        }
        sx={{
          "& .MuiAccordionSummary-expandIconWrapper": {
            position: "absolute",
            top: 16,
            right: 16,
          },
        }}
        aria-controls="panel1a-content"
      >
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Image classes={classes} pictureURL={data.pictureURL} />
          </Grid>
          <Grid item container xs={9} spacing={2}>
            <Grid item xs={12}>
              <Header classes={classes} product={product} date={data.date} />
            </Grid>
            <Grid item xs={12}>
              <Links linksPerPlatform={data.linksPerPlatform} />
            </Grid>
            <Grid item xs={12}>
              <Caption caption={data.caption} />
            </Grid>
            <Grid item xs={12}>
              <ProgressSection
                performance={data.performance}
                target={target}
                metric={data.kpiMetric}
              />
            </Grid>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Metrics data={data.metrics} classes={classes}></Metrics>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default Story;
